module.exports = __webpack_public_path__ + "kudos_56.svg?cd9b89e3cffd4b8d375fa3943118678c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_56.svg
// module id = 157
// module chunks = 0